import { useI18n } from 'app/components/localization';
import { GREY_B, WHITE_A } from 'app/constants/Colors';
import { useCss } from 'app/utils/css';
import React from 'react';
import { useBrand } from '../OrganizationContext';
import { useServerYear } from 'app/components/utilities/ServerTime';

const Copyright = () => {
  const { t } = useI18n();
  const css = useCss();

  const { isFirstParty } = useBrand();

  const currentYear = useServerYear();

  return isFirstParty ? (
    <div
      className={css('container', {
        color: WHITE_A,
        backgroundColor: GREY_B,
        fontSize: '0.6em',
        padding: '10px',
        textAlign: 'center',
        '@media print': {
          padding: '0px',
        },
      })}
    >
      {t('footer.copyright', { currentYear })}
    </div>
  ) : null;
};

export default Copyright;
